/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const HappyFaceIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M9.57084 8.79307V11.68M17.3448 8.79307V11.68M8.46875 16.7265C8.46875 16.7265 8.79344 19.5 13.4578 19.5C18.1222 19.5 18.9688 16.7265 18.9688 16.7265M25.1188 12.9383C25.1188 19.3777 19.8972 24.5992 13.4578 24.5992C7.01839 24.5992 1.79688 19.3777 1.79688 12.9383C1.79688 6.49885 7.01839 1.27734 13.4578 1.27734C19.8972 1.27734 25.1188 6.49885 25.1188 12.9383Z"
      stroke="#1D1D1B"
      strokeWidth="1.69636"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
